var _circle, _path, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 180,
    viewBox: "0 0 187 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 84.5,
    r: 74.5,
    fill: "#109CF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.5431 60.2365L108.307 65.5255C110.071 66.1147 111.265 67.7356 111.274 69.5522L111.375 85.3238C111.406 90.1051 109.663 94.742 106.471 98.3751C105.003 100.043 103.121 101.475 100.718 102.756L92.2442 107.286C91.9788 107.425 91.6871 107.498 91.393 107.5C91.0989 107.502 90.8048 107.432 90.5418 107.295L81.9892 102.87C79.5599 101.61 77.6614 100.199 76.179 98.5544C72.9344 94.9586 71.1316 90.3426 71.1005 85.5543L71.0001 69.7944C70.9906 67.9755 72.1621 66.3429 73.9171 65.7304L89.6212 60.2528C90.5537 59.9221 91.5938 59.9151 92.5431 60.2365ZM100.081 77.1443C99.3761 76.4666 98.2403 76.4712 97.5446 77.1583L89.5443 85.0441L86.2686 81.8953C85.5632 81.2176 84.4299 81.2246 83.7317 81.9116C83.0359 82.5987 83.0431 83.7026 83.7485 84.3803L88.2985 88.7587C88.6524 89.0987 89.1115 89.2664 89.5706 89.2619C90.0296 89.2594 90.4863 89.0871 90.8354 88.7424L100.096 79.613C100.792 78.9259 100.784 77.822 100.081 77.1443Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 10,
    r: 10,
    fill: "#109CF1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 179.5,
    cy: 27.5,
    r: 7.5,
    fill: "#109CF1"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.5,
    cy: 4.5,
    r: 2.5,
    fill: "#109CF1"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 133,
    r: 5,
    fill: "#109CF1"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 176.5,
    r: 3.5,
    fill: "#109CF1"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 171.5,
    cy: 110.5,
    r: 2.5,
    fill: "#109CF1"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 166.5,
    cy: 160.5,
    r: 2.5,
    fill: "#109CF1"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 75.5,
    r: 1.5,
    fill: "#109CF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.251188a0f25b9d210ed618330a994bbc.svg";
export { ForwardRef as ReactComponent };